/* Klaviyo mobile popup — lock background scroll while a popup/flyout is open.
 *
 * Problem (mobile): when the Klaviyo popup opens mid-scroll, the page keeps
 * momentum-scrolling behind it. That (a) makes the first taps on "Nein"/X get
 * eaten (registered as "stop scrolling", not click → needs ~3 taps) and (b)
 * lets a stray tap land "outside" → Klaviyo's close-on-outside fires →
 * accidental dismiss (hurts the form-submit rate).
 *
 * Fix: lock the body scroll while a popup is open (standard modal behaviour) —
 * momentum stops instantly, taps register on the first try, and there's no
 * accidental outside-dismiss from a moving background. The user's
 * close-on-outside ability stays intact (just no longer triggered by momentum).
 *
 * Scope: MOBILE only. The desktop bottom-right popup keeps its click-through
 * behaviour (see klaviyo-popup-fix.css). Uses Klaviyo's `klaviyoForms` events
 * (https://developers.klaviyo.com/en/docs/track_klaviyo_form_activity_using_javascript).
 */
(function () {
  var locked = false;
  var scrollY = 0;
  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

  function lock() {
    if (locked) return;
    scrollY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = '-' + scrollY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.classList.add('hp-klaviyo-scroll-locked');
    locked = true;
  }
  function unlock() {
    if (!locked) return;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.classList.remove('hp-klaviyo-scroll-locked');
    locked = false;
    window.scrollTo(0, scrollY);
  }

  window.addEventListener('klaviyoForms', function (e) {
    if (!e || !e.detail) return;
    var t = e.detail.type;
    if (t === 'open') {
      if (isMobile()) lock();
    } else if (t === 'close' || t === 'redirectedToUrl') {
      unlock();
    }
  });
  // Safety net: never leave the page stuck-locked if a 'close' is ever missed.
  window.addEventListener('pagehide', unlock);
})();
